import { createTheme } from '@material-ui/core';
import { MaerskColorPalette } from './app.enum';

let theme = createTheme({
	palette: {
		primary: {
			main: MaerskColorPalette.MaerskBlue,
			contrastText: MaerskColorPalette.White,
		},
		secondary: {
			main: MaerskColorPalette.DarkBlue,
			dark: MaerskColorPalette.MidBlue,
			light: MaerskColorPalette.LightBlue,
			contrastText: MaerskColorPalette.White,
		},
		success: {
			light: MaerskColorPalette.SuccessGreenLight,
			main: MaerskColorPalette.SuccessGreen,
		},
		info: {
			main: MaerskColorPalette.NotificationBorder,
			light: MaerskColorPalette.NotificationBackground,
		},
		error: {
			light: MaerskColorPalette.ErrorRedLight,
			main: MaerskColorPalette.ErrorRed,
		},
		text: {
			primary: MaerskColorPalette.Text,
		},
	},
	shape: {
		borderRadius: 0,
	},
	typography: {
		fontFamily: 'maersk-text-regular, roboto',
		h1: {
			fontFamily: 'maersk-headline-light, roboto',
			fontSize: '50pt',
		},
		h2: {
			fontFamily: 'maersk-headline-light, roboto',
			fontSize: '40pt',
		},
		h3: {
			fontFamily: 'maersk-headline-regular, roboto',
			fontSize: '26pt',
		},
		h4: {
			fontFamily: 'maersk-headline-regular, roboto',
			fontSize: '20pt',
		},
		h5: {
			fontFamily: 'maersk-text-bold, roboto',
			fontSize: '16pt',
		},
		h6: {
			fontFamily: 'maersk-text-bold, roboto',
			fontSize: '16pt',
		},
	},
	props: {
		MuiButtonBase: {
			disableRipple: true,
		},
		MuiButton: {
			variant: 'contained',
		},
		MuiCard: {
			elevation: 0,
		},
		MuiCheckbox: {
			color: 'primary',
		},
		MuiRadio: {
			color: 'primary',
		},
		MuiAccordion: {
			elevation: 0,
		},
		MuiBadge: {
			color: 'secondary',
		},
	},
});

theme = {
	...theme,
	overrides: {
		MuiAccordion: {
			root: {
				borderRadius: 2,
				borderWidth: 1,
				borderStyle: 'solid',
				borderColor: MaerskColorPalette.BorderGrey,
			},
		},
		MuiChip: {
			root: {
				backgroundColor: MaerskColorPalette.LightGrey,
			},
			colorPrimary: {
				color: MaerskColorPalette.White,
				backgroundColor: MaerskColorPalette.DarkBlue,
			},
		},
		MuiCard: {
			root: {
				borderRadius: 2,
				borderWidth: 1,
				borderStyle: 'solid',
				borderColor: MaerskColorPalette.BorderGrey,
			},
		},
		MuiListItemIcon: {
			root: {
				'& svg': {
					fontSize: 20,
				},
				marginRight: 0,
				color: MaerskColorPalette.Text,
				minWidth: 35,
				lineHeight: 1.6,
			},
		},
		MuiStepIcon: {
			text: {
				fill: MaerskColorPalette.White,
			},
		},
		MuiStepLabel: {
			root: {
				'&.Mui-disabled': {
					'& .MuiStepIcon-root, & .MuiStepLabel-label': {
						color: MaerskColorPalette.MidGrey,
					},
				},
			},
		},
		MuiOutlinedInput: {
			root: {
				borderRadius: 4,
				borderColor: MaerskColorPalette.BorderGrey,
			},
		},
		MuiButton: {
			text: {
				color: MaerskColorPalette.Text,
			},
			root: {
				borderRadius: 4,
				padding: '8px 16px',
				'&.Mui-disabled': {
					opacity: 0.5,
					color: MaerskColorPalette.Text,
				},
			},
			containedSecondary: {
				color: MaerskColorPalette.White,
				'&:hover': {
					backgroundColor: '#003d6d',
				},
				'&.Mui-disabled': {
					color: MaerskColorPalette.White,
					backgroundColor: MaerskColorPalette.DarkBlue,
					'& *': {
						color: MaerskColorPalette.White,
					},
				},
			},
			outlinedPrimary: {
				backgroundColor: MaerskColorPalette.White,
				border: '1px solid',
				borderColor: MaerskColorPalette.BorderGrey,
				color: MaerskColorPalette.Text,
				'&:hover': {
					borderColor: MaerskColorPalette.BorderGrey,
					color: MaerskColorPalette.Text,
					backgroundColor: MaerskColorPalette.UltraLightGrey,
				},
				'&:active': {
					backgroundColor: MaerskColorPalette.MidGrey,
				},
			},
			outlined: {
				padding: '8px 16px',
				backgroundColor: MaerskColorPalette.White,
				border: '1px solid',
				borderColor: MaerskColorPalette.BorderGrey,
				color: MaerskColorPalette.Text,
				'&:hover': {
					borderColor: MaerskColorPalette.BorderGrey,
					color: MaerskColorPalette.Text,
					backgroundColor: MaerskColorPalette.UltraLightGrey,
				},
				'&:active': {
					backgroundColor: MaerskColorPalette.MidGrey,
				},
			},
		},
		MuiAppBar: {
			root: {
				backgroundColor: MaerskColorPalette.White,
				borderBottomWidth: 2,
				borderBottomColor: MaerskColorPalette.BorderGrey,
				borderBottomStyle: 'solid',
			},
		},
		MuiCardContent: {
			root: {
				padding: 16,
			},
		},
		MuiToolbar: {
			regular: {
				minHeight: 48,
			},
		},
		MuiDrawer: {
			root: {
				'& .MuiToolbar-root': {
					minHeight: 55,
				},
			},
			paperAnchorDockedLeft: {
				borderRight: 0,
			},
		},
		MuiListItem: {
			selected: {
				backgroundColor: MaerskColorPalette.LightGrey,
				'&:hover': {
					backgroundColor: MaerskColorPalette.LightGrey,
				},
			},
			button: {
				'&:hover': {
					backgroundColor: MaerskColorPalette.UltraLightGrey,
				},
			},
		},
		MuiListItemText: {
			root: { color: '#141414' },
		},
		MuiStepper: {
			root: {
				padding: 0,
			},
		},
		MuiDialog: {
			paper: {
				borderRadius: 2,
			},
		},
		MuiInput: {
			underline: {
				'&:before': {
					borderBottom: `1px solid ${MaerskColorPalette.BorderGrey}`,
				},
				'&:hover:not(.Mui-disabled):before': {
					borderBottom: `2px solid ${MaerskColorPalette.BorderGrey}`,
				},
			},
		},
		MuiTab: {
			textColorSecondary: {
				color: MaerskColorPalette.DarkGrey,
			},
		},
		MuiIconButton: {
			root: {
				color: MaerskColorPalette.Text,
			},
		},
		MuiDialogActions: {
			spacing: {
				'& > :not(:first-child)': {
					marginLeft: 24,
				},
			},
		},
	},
};

export default theme;



// WEBPACK FOOTER //
// ./src/app.theme.ts